<mat-card class="preview-schedule p-20" style="height: max-content;
    
    flex: 1 1 650px;
    width: 650px;
    max-width: 95% ">
    <mat-card-header>
        <mat-card-title>Book a consultation</mat-card-title>
        <mat-card-subtitle>
            The patient encounter details will be sent to the consulting doctor
        </mat-card-subtitle>
    </mat-card-header>
    <div class="gap my-10"></div>
    <mat-card-content>
        <!-- Delivery Mode Selection -->
        @if(isPatientUser) {
        <div class="mb-20">
            <div class="booking-title mb-12" style="font-size: 1rem; color: var(--mat-sys-primary);">
                How would you like to meet?
            </div>
            <mat-radio-group [value]="deliveryMode()" (change)="deliveryMode.set($event.value)" class="g-just-flex gap-20 justify-content-start">
                <mat-radio-button value="in-person">In-Person</mat-radio-button>
                <mat-radio-button value="virtual">Virtual (Telemedicine)</mat-radio-button>
            </mat-radio-group>
        </div>
        }

        @if(showServiceSelection()) {
        <div class="mb-20">
            <div class="booking-title mb-12" style=" font-size: 1rem;
            color: var(--mat-sys-primary);
            ">
                Select a clinical service
            </div>
            <mat-form-field appearance="outline" style="width: 100%; max-width: 480px;">
                <mat-label>Clinical Department / Service</mat-label>
                <mat-select [value]="selectedService()" (valueChange)="onServiceChange($event)">
                    @for(option of serviceOptions; track option.value) {
                    <mat-option [value]="option.value">
                        <div class="g-just-flex flex-column align-items-start" style="line-height: 1.2; padding: 4px 0;">
                            <span style="font-weight: 500;">{{ option.label }}</span>
                            @if(option.specialtyDisplay) {
                            <span style="font-size: 0.75rem; color: var(--mat-sys-on-surface-variant); opacity: 0.7;">
                                {{ option.specialtyDisplay }}
                            </span>
                            }
                        </div>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
            @if(serviceOptions.length <= 2) { <div class="mt-8"
                style="font-size: 0.85rem; color: var(--mat-sys-on-surface-variant);">
                No organization-specific healthcare services found yet. The default general consultation option remains
                available.
        </div>
        }
        @if(loadingServicePractitioners) {
        <div class="mt-8" style="font-size: 0.85rem; color: var(--mat-sys-on-surface-variant);">
            Loading practitioners for the selected service…
        </div>
        } @else if(isHealthcareServiceReference(selectedService()) &&
        practitionerReferenceOptions.length === 0) {
        <div class="mt-8" style="font-size: 0.85rem; color: var(--mat-sys-on-surface-variant);">
            No practitioners are currently assigned to this healthcare service. Choose another service or link
            practitioners to it via Practitioner Roles.
        </div>
        }
        </div>
        }

        @if(isConsultationRequest()) {
        <div class="mb-20">
            <div class="booking-title mb-12" style="font-size: 1rem; color: var(--mat-sys-primary);">
                Where would you like to find a consultant?
            </div>
            <mat-radio-group [value]="consultationScope()" (change)="onConsultationScopeChange($event.value)" class="g-just-flex flex-column gap-10 align-items-start justify-content-start">
                @for(option of consultationScopeOptions(); track option.value) {
                <mat-radio-button [value]="option.value">
                    <div style="line-height: 1.2; padding: 4px 0;">
                        <span style="font-weight: 500;">{{ option.label }}</span>
                        <div style="font-size: 0.75rem; color: var(--mat-sys-on-surface-variant); opacity: 0.7;">
                            {{ option.description }}
                        </div>
                    </div>
                </mat-radio-button>
                }
            </mat-radio-group>
        </div>
        }

        @if(isPatientUser) {
        <div class="mb-20">
            <mat-checkbox [checked]="isWaitlist()" (change)="isWaitlist.set($event.checked)">
                I don't have a specific time - put me on the waitlist
            </mat-checkbox>
            <div class="mt-4" style="font-size: 0.85rem; color: var(--mat-sys-on-surface-variant);">
                Select this if you want the hospital to assign an appropriate doctor and time for you.
            </div>
        </div>
        }

        @if(!isWaitlist()) {
            <div class="mb-20">
                <div class="booking-title mb-12" style=" font-size: 1rem;
                color: var(--mat-sys-primary);
                ">
                    Select a practitioner
                </div>

                @if(practitionerReferenceOptions.length > 0) {
                <app-dynamic-forms-v2 [formMetaData]="practitionerPickerMeta" [formFields]="practitionerPickerFields"
                    (onEveryChange)="onPractitionerPickerChange($event)">
                </app-dynamic-forms-v2>

                @if(selectedPractitionerRef && (selectedPractitionerPhone || selectedPractitionerEmail)) {
                <div class="mt-12" style="font-size: 0.9rem; color: var(--mat-sys-on-surface);">
                    @if(selectedPractitionerPhone) {
                    <div>Phone: {{selectedPractitionerPhone}}</div>
                    }
                    @if(selectedPractitionerEmail) {
                    <div>Email: {{selectedPractitionerEmail}}</div>
                    }
                </div>
                }

                @if(selectedPractitionerRef && schedulesForSelectedPractitioner.length > 0) {
                <div class="mt-16">
                    <div class="booking-title mb-8" style="font-size: 0.9rem; color: var(--mat-sys-on-surface-variant);">
                        Select a schedule (optional)
                    </div>
                    <mat-form-field appearance="outline" style="width: 100%; max-width: 480px;">
                        <mat-label>Schedule</mat-label>
                        <mat-select [value]="selectedScheduleId" (valueChange)="onScheduleSelected($event)">
                            <mat-option [value]="null">All Schedules</mat-option>
                            @for(schedule of schedulesForSelectedPractitioner; track schedule.id) {
                            <mat-option [value]="schedule.id">
                                {{schedule.planningHorizon?.start | date:'mediumDate'}} –
                                {{schedule.planningHorizon?.end | date:'mediumDate'}}
                            </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
                }
                } @else {
                <div style="color: var(--mat-sys-on-surface);">
                    {{ isConsultationRequest() ? consultationPractitionerEmptyMessage() : 'No practitioners with active
                    schedules found.' }}
                </div>
                }
            </div>
        } @else {
            <!-- Waitlist Specific Fields -->
            <div class="mb-20 g-just-flex flex-column gap-20 align-items-start">
                <div class="booking-title" style="font-size: 1rem; color: var(--mat-sys-primary);">
                    Preferred Appointment Details
                </div>

                <div class="g-just-flex flex-wrap gap-20 justify-content-start">
                    <mat-form-field appearance="outline" style="width: 100%; max-width: 250px;">
                        <mat-label>Preferred Date</mat-label>
                        <input matInput [matDatepicker]="prefDate" [value]="preferredDate()" (dateChange)="preferredDate.set($event.value)">
                        <mat-datepicker-toggle matIconSuffix [for]="prefDate"></mat-datepicker-toggle>
                        <mat-datepicker #prefDate></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field appearance="outline" style="width: 100%; max-width: 250px;">
                        <mat-label>Estimated Duration (mins)</mat-label>
                        <input matInput type="number" [value]="minutesDuration()" (input)="minutesDuration.set($any($event.target).value)">
                    </mat-form-field>
                </div>

                <mat-form-field appearance="outline" style="width: 100%; max-width: 680px;">
                    <mat-label>Patient Instruction / Reason for Visit</mat-label>
                    <textarea matInput rows="4" [value]="patientInstruction()"
                        (input)="patientInstruction.set(($any($event.target).value || '').toString())"
                        placeholder="Tell us a bit about why you're booking this appointment..."></textarea>
                </mat-form-field>
            </div>
        }

        @if(isConsultationRequest()) {
        <div class="mb-20">
            <div class="booking-title mb-12" style="font-size: 1rem; color: var(--mat-sys-primary);">
                Consultation note
            </div>
            <mat-form-field appearance="outline" style="width: 100%; max-width: 680px;">
                <mat-label>Message to consultant</mat-label>
                <textarea matInput rows="4" [value]="consultationNote()"
                    (input)="consultationNote.set(($any($event.target).value || '').toString())"
                    placeholder="Add clinical context, the question for the consultant, or any handoff note."></textarea>
                <mat-hint>This note will be stored on the consultation request and included in the shared
                    document.</mat-hint>
            </mat-form-field>
        </div>
        }

        @if(showSchedule && !isWaitlist()) {
        <div class="booking-title mb-12" style=" font-size: 1rem;
        color: var(--mat-sys-primary);
        ">
            Book from the consulting doctor's available schedule
        </div>
        <div class="preview-cards-wrapper g-just-flex  justify-content-start" style="
                gap: 50px;
                flex-wrap: wrap;
                align-items: flex-start">
            <div class="calendar-preview">
                <!-- <mat-form-field appearance="outline" style=" display: block;"> -->

                <!-- <input matInput [matDatepicker]="previewSD" placeholder="01/30/2025"
                        [value]="scheduleForm?.get(['date', 'start'])?.value" style="height: 0px;">
                    <mat-hint>MM/DD/YYYY</mat-hint> -->
                <!-- <mat-datepicker-toggle matIconSuffix [for]="pickerSD"></mat-datepicker-toggle> -->

                @if(selectedPractitionerRef) {
                <mat-calendar [selected]="selected()" (selectedChange)="onDateChange($event)"
                    style="width: 300px; max-width: 100%;" [minDate]="minDate" [maxDate]="maxDate"
                    [startAt]="calendarStartAt" [dateClass]="calendarDateClass"></mat-calendar>
                } @else {
                <div
                    style="width: 300px; max-width: 100%; padding: 20px; text-align: center; color: var(--mat-sys-on-surface);">
                    Select a practitioner to view schedules.
                </div>
                }
                <!-- </mat-form-field> -->
            </div>
            <div class="time-preview" style="width: 350px; max-width: 100%;">
                <div class="time-preview-title mb-20" style="text-align: center;">
                    Available Time Slots
                </div>
                @if(!selectedPractitionerRef) {
                <div style="text-align: center; padding: 20px;">Select a practitioner first.</div>
                }
                @if(loadingSlots){
                <div style="text-align: center; padding: 20px;">Loading slots...</div>
                }
                @else if(availableSlots.length > 0){
                <div class="time-wrapper g-just-flex justify-content-start gap-30 flex-wrap"
                    style="flex-direction: column; align-items: stretch;">

                    @for(slotItem of availableSlots; track $index;){
                    <div (click)="selectSlot(slotItem)" [class.selected-slot]="selectedSlot === slotItem" style="
                        padding: 10px;
                        border: 1px solid #ccc;
                        border-radius: 4px;
                        cursor: pointer;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-bottom: 8px;
                        transition: background-color 0.2s;
                        "
                        [style.background-color]="selectedSlot === slotItem ? 'var(--mat-sys-primary-container)' : 'transparent'">
                        <div>
                            <div style="font-weight: bold;">{{slotItem.timeDisplay}}</div>
                            <div style="font-size: 0.9em; color: #666;">{{slotItem.practitionerName}}</div>
                        </div>
                        @if(selectedSlot === slotItem){
                        <mat-icon>check_circle</mat-icon>
                        }
                    </div>

                    }
                </div>

                }@else if(selected() && selectedPractitionerRef) {
                <div style="text-align: center; padding: 20px;"> No slots available for this date.</div>
                } @else {
                <div style="text-align: center; padding: 20px;"> Select a date to view available slots.</div>
                }
            </div>

        </div>
        }

        <div class="py-15 g-just-flex" style="justify-content: flex-end;">
            <button mat-flat-button (click)="sendRequest()" [disabled]="!isWaitlist() && !selectedSlot">
                {{ isWaitlist() ? 'Submit Waitlist Request' : (consultationMode === 'consult-appointment' ? 'Submit Appointment Request' : 'Send Request') }}
            </button>
        </div>

    </mat-card-content>

</mat-card>
